import React from 'react';

export function TenantWatermark({ tenant, position = 'bottom-right', size = 72, opacity = 0.1, showName = true }) {
  if (!tenant) return null;
  const pos = {
    'bottom-right': { right: 28, bottom: 24 },
    'bottom-left': { left: 28, bottom: 24 },
    'top-right': { right: 28, top: 24 },
  }[position] || { right: 28, bottom: 24 };
  const mark = tenant.crest
    ? <img src={tenant.crest} alt="" style={{ width: size, height: size, objectFit: 'contain', display: 'block' }} />
    : <div style={{ width: size, height: size, borderRadius: '50%', background: tenant.accentColor || 'var(--text-1)', color: '#fff', display: 'grid', placeItems: 'center', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: Math.round(size * 0.3) }}>{tenant.initials}</div>;
  return (
    <div aria-hidden="true" style={{ position: position === 'inline' ? 'static' : 'absolute', ...(position === 'inline' ? {} : pos), display: 'flex', alignItems: 'center', gap: 10, opacity, pointerEvents: 'none', userSelect: 'none', zIndex: 0, filter: tenant.crest ? 'grayscale(1)' : 'none' }}>
      {mark}
      {showName && <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: Math.max(11, Math.round(size * 0.22)), color: 'var(--text-1)', lineHeight: 1.15, maxWidth: size * 2.4 }}>{tenant.name}</div>}
    </div>
  );
}
